<!--
 * @Author: qixiao
 * @Date: 2022-09-06 17:24:16
 * @LastEditTime: 2022-09-23 14:02:38
 * @LastEditors: liushumin
-->
<template>
    <el-main>
        <div class="top-wrap">
            <Bread></Bread>
            <div>
                <el-form :inline="true" :model="formInline" class="demo-form-inline el-form_s">
                    <el-form-item>
                        <el-input v-model="formInline.name" placeholder="品牌名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="chaxun">查询</el-button>
                        <el-button type="primary" plain icon="el-icon-refresh-right" @click="handleReset('filterForm')">
                            清空</el-button>
                    </el-form-item>


                </el-form>
            </div>
        </div>
        <div class="main">
            <el-button icon="el-icon-plus" type="primary" style="width:110px;" @click="addBrand">添加品牌</el-button>
            <el-table v-loading="loading" :data="tableData" style="width: 100%; margin-top: 10px">
                <el-table-column label="序号" width="80" align="center">
                    <template slot-scope="scope">
                        {{ (pagination.page - 1) * pagination.size + (scope.$index + 1) }}
                    </template>
                </el-table-column>
                <el-table-column prop="brandName" label="品牌名称" min-width="8%" align="center"></el-table-column>
                <el-table-column prop="sort" label="排序" min-width="8%" align="center"></el-table-column>
                <el-table-column label="操作" min-width="8%" align="center">
                    <template slot-scope="{ row }">
                        <el-button type="primary" plain round size="small" @click="amend(row)">修改</el-button>
                        <el-button type="primary" plain round size="small" @click="removeList(row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="btm" v-show="pagination.total>10">
                <span>共{{Math.ceil(pagination.total / 10)}}页/{{pagination.total}}条数据</span>
                <el-pagination background layout="prev, pager, next,jumper" :page-size="pagination.size"
                    @size-change="handleSizeChange" :total="pagination.total" :hide-on-single-page="true"
                    @current-change="handleCurrentChange" :current-page.sync="pagination.page">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="添加品牌" :visible.sync="dialogVisible_add" width="30%">
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="120px" class="demo-dynamic">
                <el-form-item prop="name" label="品牌名称：" :rules="[
                  { required: true, message: '请输入品牌名称', trigger: 'blur' },
                ]">
                    <el-input maxlength="30" v-model="dynamicValidateForm.name" placeholder="请输入">
                    </el-input>
                </el-form-item>
                <el-form-item prop="slotNum" label="排序：">
                    <el-input maxlength="5" v-model="dynamicValidateForm.slotNum" placeholder="数字越小越靠前"></el-input>
                </el-form-item>
            </el-form>
            <div class="bottoms">
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible_add = false">取 消</el-button>
                    <el-button type="primary" @click="addTrue">确 定</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog title="修改品牌" :visible.sync="dialogVisible_amend" width="30%">
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="120px" class="demo-dynamic">
                <el-form-item prop="name" label="品牌名称：" :rules="[
                  { required: true, message: '请输入品牌名称', trigger: 'blur' },
                ]">
                    <el-input maxlength="30" v-model="dynamicValidateForm.xgname" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item prop="slotNum" label="排序：">
                    <el-input maxlength="5" v-model="dynamicValidateForm.xgslotNum" placeholder="数字越小越靠前"></el-input>
                </el-form-item>
            </el-form>
            <div class="bottoms">
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible_amend = false">取 消</el-button>
                    <el-button type="primary" @click=amendList>确 定</el-button>
                </span>
            </div>
        </el-dialog>
        <el-dialog title="修改提示" :visible.sync="dialogVisible_amendTitle" width="30%">
            <div class="fs22">
                <p>该品牌已关联<span class="reds"> {{this.removeTit}}</span> 款商品，</p>
                <p> 重新编辑后将同步修改。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="quxiaoAmend">取 消</el-button>
                <el-button type="primary" @click="awayamend">继续修改</el-button>
            </span>
        </el-dialog>
        <el-dialog title="删除品牌" :visible.sync="dialogVisible_remove" width="30%">
            <p class="fs22">是否确认删除该品牌？</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible_remove = false">取 消</el-button>
                <el-button type="primary" @click="removeTrue">确认</el-button>
            </span>
        </el-dialog>
        <el-dialog title="删除提示" :visible.sync="dialogVisible_removeTitle" width="30%">
            <div class="fs22">
                <p>有<span class="reds"> {{removeTit}}</span> 款产品已经关联该品牌，</p>
                <p>不可删除。</p>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible_removeTitle = false">我知道了</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>
<script>
import axios from 'axios'
// import JSONBIG from 'json-bigint'
export default {
    components: {},
    props: [],
    data() {
        return {
            // 搜索部分
            formInline: {
                name: '',
            },

            //弹窗展示部分

            dialogVisible_add: false,
            dialogVisible_amend: false,
            dialogVisible_amendTitle: false,
            dialogVisible_remove: false,
            dialogVisible_removeTitle: false,

            //删除操作id

            removeList_id: '',
            removeTit: '',

            // 弹窗添加数据

            dynamicValidateForm: {
                name: '测试',
                slotNum: '1',
                xgname: "",
                xgslotNum: "",
                xgid: ""
            },

            //表格部分
            tableData: [
            ],
            loading: true,

            //分页部分
            pagination: {
                page: 1,
                size: 10,
                total: 0,
            },
        };
    },
    mounted() { },
    created() {
        this.fn()
    },
    methods: {

        // 确认添加品牌

        addTrue() {
            try {
                let obj = {
                    brandName: this.dynamicValidateForm.name,
                    sort: this.dynamicValidateForm.slotNum
                }
                // axios({
                //     method: "post",
                //     url: "/cm-api/admin/brand/addBrand",
                //     params: obj
                // }).then(res => {
                //     console.log(res)
                // })
                this.$http.brandApi.getAddbrand(obj).then(res => {
                    console.log(res);
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                })
                this.dialogVisible_add = false
                this.fn()
                // this.fn()

            } catch (err) {
                console.log(err)
            }
        },

        //品牌列表

        fn() {
            let obj = {
                pageNum: this.pagination.page,
                pageSize: this.pagination.size

            }
            this.$http.brandApi.getBrandList(obj).then(res => {
                this.tableData = res.data.szProductsBrandList
                this.pagination.total = res.data.count
                this.loading = false
            })
        },



        //查询

        chaxun() {
            try {

                this.loading = true
                this.pagination.page = 1

                let obj = {
                    pageNum: 1,
                    pageSize: 10,
                    brandName: this.formInline.name
                }
                this.$http.brandApi.getBrandList(obj).then(res => {
                    console.log(res);
                    this.tableData = res.data.szProductsBrandList
                    this.pagination.total = res.data.count
                    this.loading = false
                })
            } catch (err) {
                console.log(err)
            }
        },

        //清空

        handleReset() {
            this.formInline.name = ""
            this.fn()
        },

        //添加操作

        addBrand() {
            this.dialogVisible_add = true
            this.dynamicValidateForm.slotNum = ""
            this.dynamicValidateForm.name = ""
        },

        //删除操作

        async removeList(val) {
            console.log(val.id.toString());
            await this.$http.brandApi.getRemTitle({ brandId: val.id.toString() }).then(res => {
                console.log(res);
                if (res.data == 0) {
                    this.dialogVisible_remove = true
                } else {
                    this.dialogVisible_removeTitle = true
                    this.removeTit = res.data

                }
            })
            this.removeList_id = val.id.toString()

        },
        removeTrue() {
            try {
                this.loading = true
                this.$http.brandApi.getBrandRem({ id: this.removeList_id }).then(res => {
                    console.log(res);
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                    this.dialogVisible_remove = false
                    this.loading = false

                })
                this.fn()
            } catch (err) {
                console.log(err)
            }
        },

        //修改操作

        async amend(val) {
            console.log(val.id.toString());
            await this.$http.brandApi.getRemTitle({ brandId: val.id.toString() }).then(res => {
                this.removeTit = res.data
                this.dialogVisible_amendTitle = true
                // this.dialogVisible_amend = true
            })
            this.dynamicValidateForm.xgname = val.brandName
            this.dynamicValidateForm.xgslotNum = val.sort
            this.dynamicValidateForm.xgid = val.id.toString()
            // this.awayamend()
        },
        quxiaoAmend() {
            this.dialogVisible_amendTitle = false
            this.dialogVisible_amend = false
        },
        awayamend() {
            this.dialogVisible_amend = true
            this.dialogVisible_amendTitle = false

        },
        amendList() {
            try {
                this.loading = true
                let obj = {
                    brandName: this.dynamicValidateForm.xgname,
                    sort: this.dynamicValidateForm.xgslotNum,
                    id: this.dynamicValidateForm.xgid,
                }
                this.$http.brandApi.getBrandChanged(obj).then(res => {
                    console.log(res)
                    this.$message({
                        message: res.message,
                        type: 'success'
                    });
                })
                this.dialogVisible_amend = false
                this.loading = false
                this.fn()
            } catch (err) {

            }
        },

        //分页操作

        handleCurrentChange(val) {
            console.log(val);
            // this.pagination.page = val
            let obj = {
                pageNum: val,
                pageSize: 10,
                brandName: this.formInline.name
            }
            this.$http.brandApi.getBrandList(obj).then(res => {
                console.log(res);
                this.tableData = res.data.szProductsBrandList
                this.pagination.total = res.data.count
                this.loading = false
            })
        },

        handleSizeChange(val) {

        }
    },
};
</script>

<style lang='scss' scoped>
.el-form_s {
    overflow: hidden;
}

.addBrand {
    float: right;
}

.el-dialog .el-form:not(.filter-form) .el-form-item {
    margin-bottom: 20px;
    margin-top: 4px;
}

::v-deep .el-dialog__footer {
    text-align: center;
}

::v-deep .bottoms .el-dialog .el-dialog__body {
    padding-bottom: 0;

}

.bottoms {
    text-align: center;

    .el-button {
        width: 100px;
    }
}

.fs22 {
    font-size: 22px;
    color: #444444;
    text-align: center;
}

.reds {
    color: red;
}

.el-button {
    width: 100px;
}

::v-deep .el-icon-plus {
    margin-left: -10px;
}

.btm {
    margin-top: 20px;
    text-align: center;

    span {
        display: inline-block;
        vertical-align: middle;
        font-weight: 400;
        color: #757575;
        font-size: 14px;
        margin-right: 17px;
    }

    .el-pagination {
        display: inline-block;
    }
}
</style>
